<p-toast></p-toast>
<p-card>
    <div style="text-align: center;">
        <p-progressSpinner *ngIf="loading" [style]="{width: '200px', height: '200px'}"></p-progressSpinner>
    </div>
    <div class="card" *ngIf="!loading">
        <!-- <div class="p-grid p-fluid">
            <div class="p-col-12 p-md-12 p-lg-12">
                <label for="empresa" style="font-family: system-ui;">Empresa</label>
                <p-dropdown class="p-inputtext-sm" [options]="empresas" [(ngModel)]="selecionarEmpresa"
                    [showClear]="true" optionLabel="nome_fantasia" placeholder="Selecione a Empresa"></p-dropdown>
            </div>
        </div> -->

    <div class="p-grid p-fluid">

        <div class="p-col-12 p-md-6 p-lg-4">
            <label for="selecionarFuncionario" style="font-family: system-ui;">Técnico</label>
            <p-dropdown class="p-inputtext-sm" [options]="tecnico" [(ngModel)]="selecionarFuncionario"
                [showClear]="true" optionLabel="apelido" placeholder="Selecione a Técnico"></p-dropdown>
        </div>

        <!-- <div class="p-col-12 p-md-6 p-lg-2">
            <label for="selecionarGrupo" style="font-family: system-ui;">Grupo</label>
            <p-dropdown class="p-inputtext-sm" [options]="grupo" [(ngModel)]="selecionarGrupo"
            [showClear]="true" optionLabel="nome" placeholder="Selecione a Grupo"></p-dropdown>
        </div> -->

        <div class="p-col-12 p-md-6 p-lg-2">
            <label for="selecionarSetor" style="font-family: system-ui;">Setor</label>
            <p-dropdown class="p-inputtext-sm" [options]="setor" [(ngModel)]="selecionarSetor"
            [showClear]="true" optionLabel="nome" placeholder="Selecione a Setor"></p-dropdown>
        </div>
    </div>    

        <div class="p-grid p-fluid">
            <div class="p-col-12 p-md-6 p-lg-2">
                <label for="selecionarPeriodo" style="font-family: system-ui;">Período</label>
                <p-dropdown class="p-inputtext-sm" [options]="periodos" [(ngModel)]="selecionarPeriodo"
                    optionLabel="nome" optionValue="nome" (onChange)="onChangePeriodo($event)"></p-dropdown>
            </div>

            <div class="p-col-12 p-md-6 p-lg-2">
                <label style="font-family: system-ui;">Data Inicial</label>
                <p-calendar class="p-inputtext-sm" [(ngModel)]="data_inicial" dateFormat="dd/mm/yy" [showIcon]="true"
                    inputId="icon" showButtonBar="true">
                </p-calendar>
            </div>

            <div class="p-col-12 p-md-6 p-lg-2">
                <label style="font-family: system-ui;">Data Final</label>
                <p-calendar class="p-inputtext-sm" [(ngModel)]="data_final" dateFormat="dd/mm/yy" [showIcon]="true"
                    inputId="icon" showButtonBar="true">
                </p-calendar>
            </div>

            <div class="p-col-12 p-md-6 p-lg-2" style="align-self: flex-end;">
                <button style="height: 39.272px; background-color: rgb(167, 32, 8);" pButton pRipple type="button" label="Pesquisar"
                    class="p-button-raised" (click)="pesquisar()"></button>
            </div>


        </div>
        <div class="p-grid nested-grid">
            <div class="p-col-12 p-md-6 p-lg-7">
                <p-table #dt [value]="lista" selectionMode="single"
                    styleClass="p-datatable-sm p-datatable-striped" dataKey="descricaoTitulo" [scrollable]="true"
                    scrollHeight="300px" (onRowSelect)="onRowSelect($event)">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="text-align:left;width:400px">Atendimento</th>
                            <th style="text-align:right">Total</th>
                            <th style="text-align:right">Realizadas</th>
                            <th style="text-align:right">A realizar</th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-cliente>
                        <tr [pSelectableRow]="cliente">
                            <td style="text-align:left;width:400px"><b>{{cliente.descricaoTitulo}}</b></td>
                            <td style="text-align:right">{{cliente.total_atendimento}}</td>
                            <td style="text-align:right">{{cliente.Resolvidos}}</td>
                            <td style="text-align:right">{{cliente.NaoResolvidos}}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <div class="p-col-12 p-md-6 p-lg-5">
                <p-chart type="pie" [data]="grafico"></p-chart>
            </div>
        </div>

        <!-- <div class="p-grid nested-grid">
            <div class="p-col-12 p-md-6 p-lg-12">
                <p-chart type="polarArea" [data]="grafico_bar"></p-chart>
            </div>
        </div> -->
    </div>
</p-card>

<!-- TECNICA -->
<p-dialog header="RELATÓRIO DE ELEVADORES CRÍTICOS" [(visible)]="displayTecnica" [modal]="true" [style]="{width: '90vw'}"
    [baseZIndex]="10000">

    <p-table #dt [value]="listaTecnica" selectionMode="single" styleClass="p-datatable-sm p-datatable-striped"
        dataKey="origem" [scrollable]="true">
        <ng-template pTemplate="header">
            <tr>
                <th style="font-size:10px">Cliente</th>
                <th style="font-size:10px">Endereço</th>
                <th style="font-size:10px">Elevador</th>
                <th style="font-size:10px">tipo_equipamento</th>
                <th style="font-size:10px; text-align: right;">Quantidade</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-cliente>
            <tr [pSelectableRow]="cliente">
                <td style="text-align:left;font-size:10px">{{cliente.cliente}}</td>
                <td style="text-align: left;font-size:10px">{{cliente.endereco}}</td>
                <td style="text-align: left;font-size:10px">{{cliente.elevador}}</td>
                <td style="text-align: left;font-size:10px">{{cliente.tipo_equipamento}}</td>
                <td style="font-size:10px; text-align: right;">{{cliente.qtd}}</td>
            </tr>
        </ng-template>
    </p-table>
    <div>

    </div>
    <ng-template pTemplate="footer">
        <div>
            <span style="
            background-color: cornflowerblue;
            padding: 5px;
            border-radius: 10px;
            float: left;
        "><b>TOTAL : {{totalTecnica}}</b></span>
            <p-button icon="pi pi-check" (click)="displayTecnica=false" label="FECHAR"
                styleClass="p-button-text">
            </p-button>
        </div>

    </ng-template>
</p-dialog>
<!-- FIM TECNICA -->
